import React from 'react';
import PropTypes from 'prop-types';
import './table.scss';

const Table = ({tableTitle, tableHeader, tableBodyData, tableTotalData}) => {
  return (
    <div className="glu-table">
      <p className="glu-table__title">{tableTitle}</p>

      <table className="glu-table__table">
        <thead>
          <tr>
            {tableHeader &&
              tableHeader.map((header) => (
                <th key={header} className="glu-table__header-cell">
                  {header}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {tableBodyData &&
            tableBodyData.map(([id, data]) => (
              <tr key={id}>
                {data.map((cell, inx) => (
                  <td
                    /* eslint-disable-next-line react/no-array-index-key */
                    key={`${inx}-${cell}`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          <tr className="glu-table__total" key="total">
            {tableTotalData &&
              tableTotalData.map((cell, inx) => (
                <td
                  /* eslint-disable-next-line react/no-array-index-key */
                  key={`${inx}-${cell}`}
                >
                  {cell}
                </td>
              ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  tableTitle: PropTypes.string,
  tableHeader: PropTypes.arrayOf(PropTypes.any).isRequired,
  tableBodyData: PropTypes.arrayOf(PropTypes.any).isRequired,
  tableTotalData: PropTypes.arrayOf(PropTypes.any).isRequired,
};

Table.defaultProps = {
  tableTitle: '',
};

export default Table;
